import { ComponentType } from 'react';
import { GetReviewResponseData } from 'src/app/api/model/response/GetReviewResponse';
import ODQAndReliabilityReview from 'src/app/component/odqAndReliability/ODQAndReliabilityReview';

/**
 * Maps uiLayoutId to a custom React layout component.
 */
export interface CustomLayoutProps {
    reviewId: string;
    data: GetReviewResponseData;
}

export const layoutRegistry: Record<string, ComponentType<CustomLayoutProps>> = {
    "ODQ_AND_RELIABILITY_CUSTOM_LAYOUT": ODQAndReliabilityReview
};
